import Api from "../apis/Api";

export default {
	data() {
		return {
			dnsRecordsToSet: [],
			showStartCreatingButton: false,
		}
	},
	methods: {
		async wpAdminSsoRedirect(skipDelay = false) {
			if (this.selectedService.id === 0) {
				return;
			}

			if (skipDelay) {
				await this.performSsoRedirect();
				return;
			}

			const sslDetected = await this.checkSslAndRedirect();
			if (sslDetected) {
				return;
			}

			const checkInterval = 5000;
			const totalTimeout = this.selectedService.onboarding.super_quick_redirect_delay_after_site_creation * 1000;
			const startTime = Date.now();

			const intervalId = setInterval(async () => {
				const elapsedTime = Date.now() - startTime;

				if (elapsedTime >= totalTimeout) {
					clearInterval(intervalId);

					await this.checkSslAndRedirect();
					setTimeout(async () => {
						await this.performSsoRedirect();
					}, 100);
					
					return;
				}

				const sslDetected = await this.checkSslAndRedirect();
				if (sslDetected) {
					clearInterval(intervalId);
				}
			}, checkInterval);
		},
		async checkSslAndRedirect() {
			try {
				const data = await Api.get('instances/onboarding/ssl-certificate?domain=' + this.installedInstance.domain);

				if (data.data.is_ssl_certificate_detected) {
					await this.performSsoRedirect();
					return true;
				}

				return false;
			} catch (error) {
				console.error('Error checking SSL certificate:', error);
				return false;
			}
		},
		async performSsoRedirect() {
			try {
				const response = await Api.post(
					`/instances/${this.installedInstance.id}/sso-url`,
					{user: 1}
				);

				window.location.href = response.data.data.sso_url;
			} catch (error) {
				this.showStartCreatingButton = true;

				this.$store.dispatch("addAlert", {
					success: false,
					errorMessage: Api.getErrorMessage(error),
				});
			} finally {
				this.installationCompleted = true;
				this.installationError = false;
			}
		},
	}
}
